import { createContext, useState } from "react";

export const RegionContext = createContext();

export const RegionProvider = ({ children }) => {
  const [selectedRegionId, setSelectedRegionId] = useState(
    localStorage.getItem("selectedRegionId") || null
  );

  const updateSelectedRegionId = (regionId) => {
    localStorage.setItem("selectedRegionId", regionId);
    setSelectedRegionId(regionId);
  };

  return (
    <RegionContext.Provider
      value={{ selectedRegionId, updateSelectedRegionId }}
    >
      {children}
    </RegionContext.Provider>
  );
};
